export interface IActivityBusinessMeta {
    kind: string;
    implementer: string;
    subs: string[];
    lock: boolean;
    enabled: boolean;
    setting: unknown;
}

export interface IActivityThemeImageDrawOption {
    title: string;
}

export interface IActivityThemeImageDrawOptionImage extends IActivityThemeImageDrawOption {
    image_url: string;
}

export interface IActivityThemeImageDrawOptionText extends IActivityThemeImageDrawOption {
    length_max: number;
    length_min: number;
    text: string;
    title: string;
}

export interface IActivityThemeImageDraw {
    x: number;
    y: number;
    type: string;
    option: IActivityThemeImageDrawOptionImage | IActivityThemeImageDrawOptionText | unknown;
    is_public: boolean;
}

export interface IActivityThemeImage {
    image_url: string;
    draws: IActivityThemeImageDraw[];
}

export interface IActivityCard {
    header_image_url: string;
    margin: number[];
    draws: IActivityThemeImageDraw[];
    footer_image_url: string;
}

export interface IActivityTheme {
    theme_id: string | null;
    share_title_template: string;
    card: IActivityCard;
    keys: number[];
    images: IActivityThemeImage[][];
}

export interface IDependencies {
    dependencies: string[];
}

export interface IActivityCardMetadata {
    title: string;
    material_image_url: string;
    images: string[];
}

export interface IActivitySection extends IDependencies {
    id: string;
    name: string;
    can_hide: boolean;
    is_hide: boolean;
    card?: IActivityCardMetadata;
}

export interface IActivityNotifyChannel {
    implementer: string;
    enabled: boolean;
    template_id: string;
}

export interface IActivityNotifyCondition {
    target: string;
    relation: '∈' | '∉' | '=' | '≠';
    status: string[];
}

export interface IActivityNotifyRule {
    name: string;
    enabled: boolean;
    listen_event_id: string;
    notify_target: string;
    dependencies: string[];
    intervals: {
        is_advance: boolean;
        //  时间单位：分钟
        value: number;
    }[];
    conditions: IActivityNotifyCondition[]
    channels: IActivityNotifyChannel[]
}

export interface IActivityUXPage {
    action_bar: IActivitySection[],
    body: IActivitySection[],
    status_bar: IActivitySection[],
    popups: IActivitySection[]
}

export enum EActivityStatus {active = 'active', preheating = 'preheating', finished = 'finished'}

export const DEActivityStatusMap: Record<EActivityStatus, string> = {
    [EActivityStatus.preheating]: '预热期',
    [EActivityStatus.active]: '活动期',
    [EActivityStatus.finished]: '已结束'
};

export interface IActivityUX {
    pages: Record<EActivityStatus, IActivityUXPage>
    notify_rules: IActivityNotifyRule[] // [事件ID]参数
}

export interface IActivityAD {
    status: 'system' | 'none' | 'custom'
    custom: {
        entrance_prompt: string
        popup_prompt: string
        contact_name: string
        contact_phone_number: string
        contact_wechat_qr_string: string
    }
}

export interface IActivityEmployee {
    verification_permission: boolean;
    team_name: string;
}

export interface IActivityBranchStatus {
    merchant_id: string;
    applet_id: string;
    employees: Record<string, IActivityEmployee>
}

export interface IActivityInfo {
    activity_id: string;
    agent_id: string;
    tags: string[];
    preview: {
        title: string;
        image_url: string;
    };
    begin_at: string;
    end_at: string;
    publish_at: string | null;
    trash_at: string | null;
    create_at: string;
}

export interface IActivityMetadata extends IActivityInfo {
    branches: Record<string, IActivityBranchStatus>
    title_template: string;
    theme: Record<EActivityStatus, IActivityTheme>;
    businesses: Record<EActivityStatus, IActivityBusinessMeta[]>;
    ux: IActivityUX;
    ad: IActivityAD;
}
